import "./EditProduct.scss";
import { BackButton } from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { useEditProduct } from "./useEditProduct";

const EditProduct = () => {
  const {
    isUpdatingProduct,
    isFetchingProduct,
    productDetails,
    handleProductUpdate,
  } = useEditProduct();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Product"
      description="Edit product details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          className="edit-single-product-page"
        >
          <div>
            <BackButton />
          </div>

          <div className="edit-single-product-page__content">
            <div className="edit-single-product-page__content-heeader">
              <h3 className="font-weight-semibold">Edit product</h3>
              <p>Please provide the following information about your product</p>
            </div>
            <secondaryComponents.LoaderHelper
              isLoading={isFetchingProduct}
              classNames="mt-5"
            >
              <secondaryComponents.SingleProductForm
                isEditMode={true}
                productDetails={productDetails}
                isUpdatingProduct={isUpdatingProduct}
                handleProductUpdate={handleProductUpdate}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default EditProduct;
